import "./SitesListWidget.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { SitesListWidgetComponentController } from "./SitesListWidgetComponentController";

export class SitesListWidgetComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = SitesListWidgetComponentController;
        this.templateUrl = "/App/Modules/Gui/Components/Widgets/SitesList/SitesListWidget.html";
    }
}
